import { render, staticRenderFns } from "./OrdersFBMTableUserFilter.vue?vue&type=template&id=6c0d07f8&scoped=true"
import script from "./OrdersFBMTableUserFilter.vue?vue&type=script&lang=js"
export * from "./OrdersFBMTableUserFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0d07f8",
  null
  
)

export default component.exports